import { c as _c } from "react/compiler-runtime";
import { parseAsString, parseAsStringLiteral, useQueryStates } from 'nuqs';
import { SUBSECTIONS_KEYS, type Subsection } from '@/components/entity-onboarding-details/onboarding-data.types';
import { getSubsectionAnchorId, ONBOARDINGS_ID } from '../constants';
import { pinScrollPosition } from '../utils';

/** Scrolls to a section of the selected onboarding, or to the strip, and holds it there while the page loads. */
const scrollToOnboarding = (subsection?: Subsection) => {
  const element = subsection && document.getElementById(getSubsectionAnchorId(subsection)) || document.getElementById(ONBOARDINGS_ID);
  if (!element) {
    return;
  }
  element.scrollIntoView({
    block: 'start'
  });
  pinScrollPosition(element, element.getBoundingClientRect().top);
  // Clear the anchor after landing so tab changes don't scroll back to it.
  if (window.location.hash === `#${ONBOARDINGS_ID}`) {
    window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
  }
};
const ONBOARDING_SECTION_SCROLL_EVENT = 'onboarding-section-scroll';
type OnboardingSectionScrollRequest = {
  id: string;
  subsection: Subsection;
};
const useShowOnboarding = () => {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      onboarding_id: parseAsString,
      onboarding_section: parseAsStringLiteral(SUBSECTIONS_KEYS)
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [t1, setState] = useQueryStates(t0);
  const {
    onboarding_id: onboardingId,
    onboarding_section: onboardingSection
  } = t1;
  let t2;
  if ($[1] !== setState) {
    t2 = id => setState({
      onboarding_id: id
    });
    $[1] = setState;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setOnboardingId = t2;
  let t3;
  if ($[3] !== setState) {
    t3 = section => setState({
      onboarding_section: section
    });
    $[3] = setState;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const setOnboardingSection = t3;
  let t4;
  if ($[5] !== setState) {
    t4 = async (id_0, subsection) => {
      await setState(subsection ? {
        onboarding_id: id_0,
        onboarding_section: subsection
      } : {
        onboarding_id: id_0
      });
      if (subsection) {
        const event = new CustomEvent(ONBOARDING_SECTION_SCROLL_EVENT, {
          detail: {
            id: id_0,
            subsection
          },
          cancelable: true
        });
        if (!window.dispatchEvent(event)) {
          return;
        }
      }
      requestAnimationFrame(() => scrollToOnboarding(subsection));
    };
    $[5] = setState;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const scrollOnboardingIntoView = t4;
  let t5;
  if ($[7] !== onboardingId || $[8] !== onboardingSection || $[9] !== scrollOnboardingIntoView || $[10] !== setOnboardingId || $[11] !== setOnboardingSection) {
    t5 = {
      onboardingId,
      onboardingSection,
      setOnboardingId,
      setOnboardingSection,
      scrollOnboardingIntoView
    };
    $[7] = onboardingId;
    $[8] = onboardingSection;
    $[9] = scrollOnboardingIntoView;
    $[10] = setOnboardingId;
    $[11] = setOnboardingSection;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export type { OnboardingSectionScrollRequest };
export { ONBOARDING_SECTION_SCROLL_EVENT, scrollToOnboarding };
export default useShowOnboarding;